export class Stakeholder {
  userId?: number;
  ssoId?: string;
  name!: string;
  email!: string;
  organisation!: string;
  phonenumber?: string;
  supporting?: boolean;
}
